import { render, staticRenderFns } from "./virtualization_component.vue?vue&type=template&id=26d4edae&scoped=true&"
import script from "./virtualization_component.vue?vue&type=script&lang=js&"
export * from "./virtualization_component.vue?vue&type=script&lang=js&"
import style0 from "./virtualization_component.vue?vue&type=style&index=0&id=26d4edae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d4edae",
  null
  
)

export default component.exports